"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.JavaScriptObfuscatorCLI = void 0;
const commander = __importStar(require("commander"));
const path = __importStar(require("path"));
const TInputCLIOptions_1 = require("../types/options/TInputCLIOptions");
const Initializable_1 = require("../decorators/Initializable");
const IdentifierNamesGenerator_1 = require("../enums/generators/identifier-names-generators/IdentifierNamesGenerator");
const LoggingPrefix_1 = require("../enums/logger/LoggingPrefix");
const ObfuscationTarget_1 = require("../enums/ObfuscationTarget");
const OptionsPreset_1 = require("../enums/options/presets/OptionsPreset");
const RenamePropertiesMode_1 = require("../enums/node-transformers/rename-properties-transformers/RenamePropertiesMode");
const SourceMapMode_1 = require("../enums/source-map/SourceMapMode");
const SourceMapSourcesMode_1 = require("../enums/source-map/SourceMapSourcesMode");
const StringArrayEncoding_1 = require("../enums/node-transformers/string-array-transformers/StringArrayEncoding");
const StringArrayIndexesType_1 = require("../enums/node-transformers/string-array-transformers/StringArrayIndexesType");
const StringArrayWrappersType_1 = require("../enums/node-transformers/string-array-transformers/StringArrayWrappersType");
const Default_1 = require("../options/presets/Default");
const ArraySanitizer_1 = require("./sanitizers/ArraySanitizer");
const BooleanSanitizer_1 = require("./sanitizers/BooleanSanitizer");
const CLIUtils_1 = require("./utils/CLIUtils");
const IdentifierNamesCacheFileUtils_1 = require("./utils/IdentifierNamesCacheFileUtils");
const JavaScriptObfuscatorFacade_1 = require("../JavaScriptObfuscatorFacade");
const Logger_1 = require("../logger/Logger");
const ObfuscatedCodeFileUtils_1 = require("./utils/ObfuscatedCodeFileUtils");
const SourceCodeFileUtils_1 = require("./utils/SourceCodeFileUtils");
const Utils_1 = require("../utils/Utils");
class JavaScriptObfuscatorCLI {
    constructor(argv) {
        this.rawArguments = argv;
        this.arguments = argv.slice(2);
    }
    static buildOptions(inputOptions) {
        const inputCLIOptions = JavaScriptObfuscatorCLI.filterOptions(inputOptions);
        const configFilePath = inputOptions.config;
        const configFileLocation = configFilePath ? path.resolve(configFilePath, '.') : '';
        const configFileOptions = configFileLocation ? CLIUtils_1.CLIUtils.getUserConfig(configFileLocation) : {};
        return {
            ...Default_1.DEFAULT_PRESET,
            ...configFileOptions,
            ...inputCLIOptions
        };
    }
    static filterOptions(options) {
        const filteredOptions = {};
        Object
            .keys(options)
            .forEach((option) => {
            if (options[option] === undefined) {
                return;
            }
            filteredOptions[option] = options[option];
        });
        return filteredOptions;
    }
    initialize() {
        this.commands = new commander.Command();
        this.configureCommands();
        this.configureHelp();
        this.inputPath = path.normalize(this.commands.args[0] || '');
        this.inputCLIOptions = JavaScriptObfuscatorCLI.buildOptions(this.commands.opts());
        this.sourceCodeFileUtils = new SourceCodeFileUtils_1.SourceCodeFileUtils(this.inputPath, this.inputCLIOptions);
        this.obfuscatedCodeFileUtils = new ObfuscatedCodeFileUtils_1.ObfuscatedCodeFileUtils(this.inputPath, this.inputCLIOptions);
        this.identifierNamesCacheFileUtils = new IdentifierNamesCacheFileUtils_1.IdentifierNamesCacheFileUtils(this.inputCLIOptions.identifierNamesCachePath);
    }
    run() {
        const canShowHelp = !this.arguments.length || this.arguments.includes('--help');
        if (canShowHelp) {
            this.commands.outputHelp();
            return;
        }
        const sourceCodeData = this.sourceCodeFileUtils.readSourceCode();
        this.processSourceCodeData(sourceCodeData);
    }
    configureCommands() {
        this.commands
            .usage('<inputPath> [options]')
            .version(Utils_1.Utils.buildVersionMessage(process.env.VERSION, process.env.BUILD_TIMESTAMP), '-v, --version')
            .option('-o, --output <path>', 'Output path for obfuscated code')
            .option('--compact <boolean>', 'Disable one line output code compacting', BooleanSanitizer_1.BooleanSanitizer)
            .option('--config <boolean>', 'Name of js / json config file')
            .option('--control-flow-flattening <boolean>', 'Enables control flow flattening', BooleanSanitizer_1.BooleanSanitizer)
            .option('--control-flow-flattening-threshold <number>', 'The probability that the control flow flattening transformation will be applied to the node', parseFloat)
            .option('--dead-code-injection <boolean>', 'Enables dead code injection', BooleanSanitizer_1.BooleanSanitizer)
            .option('--dead-code-injection-threshold <number>', 'The probability that the dead code injection transformation will be applied to the node', parseFloat)
            .option('--debug-protection <boolean>', 'Disable browser Debug panel (can cause DevTools enabled browser freeze)', BooleanSanitizer_1.BooleanSanitizer)
            .option('--debug-protection-interval <number>', 'Sets interval in milliseconds for debug protection so it is working even after page was loaded (can cause DevTools enabled browser freeze)', parseInt)
            .option('--disable-console-output <boolean>', 'Allow console.log, console.info, console.error and console.warn messages output into browser console', BooleanSanitizer_1.BooleanSanitizer)
            .option('--domain-lock <list> (comma separated, without whitespaces)', 'Allows to run the obfuscated source code only on specific domains and/or sub-domains (comma separated)', ArraySanitizer_1.ArraySanitizer)
            .option('--domain-lock-redirect-url <string>', 'Allows the browser to be redirected to a passed URL if the source code isn\'t run on the domains specified by --domain-lock')
            .option('--exclude <list> (comma separated, without whitespaces)', 'A filename or glob which indicates files to exclude from obfuscation', ArraySanitizer_1.ArraySanitizer)
            .option('--force-transform-strings <list> (comma separated, without whitespaces)', 'Enables force transformation of string literals, which being matched by passed RegExp patterns (comma separated)', ArraySanitizer_1.ArraySanitizer)
            .option('--identifier-names-cache-path <string>', 'Sets path for identifier names cache')
            .option('--identifier-names-generator <string>', 'Sets identifier names generator. ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(IdentifierNamesGenerator_1.IdentifierNamesGenerator)}. ` +
            `Default: ${IdentifierNamesGenerator_1.IdentifierNamesGenerator.HexadecimalIdentifierNamesGenerator}`)
            .option('--identifiers-prefix <string>', 'Sets prefix for all global identifiers')
            .option('--identifiers-dictionary <list> (comma separated, without whitespaces)', 'Identifiers dictionary (comma separated) for `--identifier-names-generator dictionary` option', ArraySanitizer_1.ArraySanitizer)
            .option('--ignore-imports <boolean>', 'Prevents obfuscation of `require` and `dynamic` imports', BooleanSanitizer_1.BooleanSanitizer)
            .option('--log <boolean>', 'Enables logging of the information to the console', BooleanSanitizer_1.BooleanSanitizer)
            .option('--numbers-to-expressions <boolean>', 'Enables numbers conversion to expressions', BooleanSanitizer_1.BooleanSanitizer)
            .option('--options-preset <string>', 'Allows to set options preset. ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(OptionsPreset_1.OptionsPreset)}. ` +
            `Default: ${OptionsPreset_1.OptionsPreset.Default}`)
            .option('--reserved-names <list> (comma separated, without whitespaces)', 'Disables obfuscation and generation of identifiers, which being matched by passed RegExp patterns (comma separated)', ArraySanitizer_1.ArraySanitizer)
            .option('--reserved-strings <list> (comma separated, without whitespaces)', 'Disables transformation of string literals, which being matched by passed RegExp patterns (comma separated)', ArraySanitizer_1.ArraySanitizer)
            .option('--rename-globals <boolean>', 'Allows to enable obfuscation of global variable and function names with declaration', BooleanSanitizer_1.BooleanSanitizer)
            .option('--rename-properties <boolean>', 'UNSAFE: Enables renaming of property names. This probably MAY break your code', BooleanSanitizer_1.BooleanSanitizer)
            .option('--rename-properties-mode <boolean>', 'Specify `--rename-properties` option mode. ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(RenamePropertiesMode_1.RenamePropertiesMode)}. ` +
            `Default: ${RenamePropertiesMode_1.RenamePropertiesMode.Safe}`)
            .option('--seed <string|number>', 'Sets seed for random generator. This is useful for creating repeatable results.', parseFloat)
            .option('--self-defending <boolean>', 'Disables self-defending for obfuscated code', BooleanSanitizer_1.BooleanSanitizer)
            .option('--simplify <boolean>', 'Enables additional code obfuscation through simplification', BooleanSanitizer_1.BooleanSanitizer)
            .option('--source-map <boolean>', 'Enables source map generation', BooleanSanitizer_1.BooleanSanitizer)
            .option('--source-map-base-url <string>', 'Sets base url to the source map import url when `--source-map-mode=separate`')
            .option('--source-map-file-name <string>', 'Sets file name for output source map when `--source-map-mode=separate`')
            .option('--source-map-mode <string>', 'Specify source map output mode. ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(SourceMapMode_1.SourceMapMode)}. ` +
            `Default: ${SourceMapMode_1.SourceMapMode.Separate}`)
            .option('--source-map-sources-mode <string>', 'Specify source map sources mode. ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(SourceMapSourcesMode_1.SourceMapSourcesMode)}. ` +
            `Default: ${SourceMapSourcesMode_1.SourceMapSourcesMode.SourcesContent}`)
            .option('--split-strings <boolean>', 'Splits literal strings into chunks with length of `splitStringsChunkLength` option value', BooleanSanitizer_1.BooleanSanitizer)
            .option('--split-strings-chunk-length <number>', 'Sets chunk length of `splitStrings` option', parseFloat)
            .option('--string-array <boolean>', 'Enables gathering of all literal strings into an array and replacing every literal string with an array call', BooleanSanitizer_1.BooleanSanitizer)
            .option('--string-array-calls-transform <boolean>', 'Enables the transformation of calls to the string array', BooleanSanitizer_1.BooleanSanitizer)
            .option('--string-array-calls-transform-threshold <number>', 'The probability that that calls to the string array will be transformed', parseFloat)
            .option('--string-array-encoding <list> (comma separated, without whitespaces)', 'Encodes each string in strings array using base64 or rc4 (this option can slow down your code speed). ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(StringArrayEncoding_1.StringArrayEncoding)}. ` +
            `Default: ${StringArrayEncoding_1.StringArrayEncoding.None}`, ArraySanitizer_1.ArraySanitizer)
            .option('--string-array-indexes-type <list> (comma separated, without whitespaces)', 'Encodes each string in strings array using base64 or rc4 (this option can slow down your code speed). ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(StringArrayIndexesType_1.StringArrayIndexesType)}. ` +
            `Default: ${StringArrayIndexesType_1.StringArrayIndexesType.HexadecimalNumber}`, ArraySanitizer_1.ArraySanitizer)
            .option('--string-array-index-shift <boolean>', 'Enables additional index shift for all string array calls', BooleanSanitizer_1.BooleanSanitizer)
            .option('--string-array-rotate <boolean>', 'Enable rotation of string array values during obfuscation', BooleanSanitizer_1.BooleanSanitizer)
            .option('--string-array-shuffle <boolean>', 'Randomly shuffles string array items', BooleanSanitizer_1.BooleanSanitizer)
            .option('--string-array-wrappers-count <number>', 'Sets the count of wrappers for the string array inside each root or function scope', parseInt)
            .option('--string-array-wrappers-chained-calls <boolean>', 'Enables the chained calls between string array wrappers', BooleanSanitizer_1.BooleanSanitizer)
            .option('--string-array-wrappers-parameters-max-count <number>', 'Allows to control the maximum number of string array wrappers parameters', parseInt)
            .option('--string-array-wrappers-type <string>', 'Allows to select a type of the wrappers that are appending by the `--string-array-wrappers-count` option. ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(StringArrayWrappersType_1.StringArrayWrappersType)}. ` +
            `Default: ${StringArrayWrappersType_1.StringArrayWrappersType.Variable}`)
            .option('--string-array-threshold <number>', 'The probability that the literal string will be inserted into stringArray (Default: 0.8, Min: 0, Max: 1)', parseFloat)
            .option('--target <string>', 'Allows to set target environment for obfuscated code. ' +
            `Values: ${CLIUtils_1.CLIUtils.stringifyOptionAvailableValues(ObfuscationTarget_1.ObfuscationTarget)}. ` +
            `Default: ${ObfuscationTarget_1.ObfuscationTarget.Browser}`)
            .option('--transform-object-keys <boolean>', 'Enables transformation of object keys', BooleanSanitizer_1.BooleanSanitizer)
            .option('--unicode-escape-sequence <boolean>', 'Allows to enable/disable string conversion to unicode escape sequence', BooleanSanitizer_1.BooleanSanitizer)
            .parse(this.rawArguments);
    }
    configureHelp() {
        this.commands.on('--help', () => {
            console.log('  Examples:\n');
            console.log('    %> javascript-obfuscator input_file_name.js --compact true --self-defending false');
            console.log('    %> javascript-obfuscator input_file_name.js --output output_file_name.js --compact true --self-defending false');
            console.log('    %> javascript-obfuscator input_directory_name --compact true --self-defending false');
            console.log('');
        });
    }
    processSourceCodeData(sourceCodeData) {
        sourceCodeData.forEach(({ filePath, content }, index) => {
            const outputCodePath = this.obfuscatedCodeFileUtils.getOutputCodePath(filePath);
            try {
                Logger_1.Logger.log(Logger_1.Logger.colorInfo, LoggingPrefix_1.LoggingPrefix.CLI, `Obfuscating file: ${filePath}...`);
                this.processSourceCode(content, filePath, outputCodePath, index);
            }
            catch (error) {
                Logger_1.Logger.log(Logger_1.Logger.colorInfo, LoggingPrefix_1.LoggingPrefix.CLI, `Error in file: ${filePath}...`);
                throw error;
            }
        });
    }
    processSourceCode(sourceCode, inputCodePath, outputCodePath, sourceCodeIndex) {
        const options = {
            ...this.inputCLIOptions,
            identifierNamesCache: this.identifierNamesCacheFileUtils.readFile(),
            inputFileName: path.basename(inputCodePath),
            ...sourceCodeIndex !== null && {
                identifiersPrefix: Utils_1.Utils.getIdentifiersPrefixForMultipleSources(this.inputCLIOptions.identifiersPrefix, sourceCodeIndex)
            }
        };
        if (options.sourceMap) {
            this.processSourceCodeWithSourceMap(sourceCode, outputCodePath, options);
        }
        else {
            this.processSourceCodeWithoutSourceMap(sourceCode, outputCodePath, options);
        }
    }
    processSourceCodeWithoutSourceMap(sourceCode, outputCodePath, options) {
        const obfuscationResult = JavaScriptObfuscatorFacade_1.JavaScriptObfuscator.obfuscate(sourceCode, options);
        this.obfuscatedCodeFileUtils.writeFile(outputCodePath, obfuscationResult.getObfuscatedCode());
        this.identifierNamesCacheFileUtils.writeFile(obfuscationResult.getIdentifierNamesCache());
    }
    processSourceCodeWithSourceMap(sourceCode, outputCodePath, options) {
        var _a;
        const outputSourceMapPath = this.obfuscatedCodeFileUtils.getOutputSourceMapPath(outputCodePath, (_a = options.sourceMapFileName) !== null && _a !== void 0 ? _a : '');
        options = {
            ...options,
            sourceMapFileName: path.basename(outputSourceMapPath)
        };
        const obfuscationResult = JavaScriptObfuscatorFacade_1.JavaScriptObfuscator.obfuscate(sourceCode, options);
        this.obfuscatedCodeFileUtils.writeFile(outputCodePath, obfuscationResult.getObfuscatedCode());
        this.identifierNamesCacheFileUtils.writeFile(obfuscationResult.getIdentifierNamesCache());
        if (options.sourceMapMode === SourceMapMode_1.SourceMapMode.Separate && obfuscationResult.getSourceMap()) {
            this.obfuscatedCodeFileUtils.writeFile(outputSourceMapPath, obfuscationResult.getSourceMap());
        }
    }
}
JavaScriptObfuscatorCLI.availableInputExtensions = [
    '.js'
];
JavaScriptObfuscatorCLI.encoding = 'utf8';
JavaScriptObfuscatorCLI.obfuscatedFilePrefix = '-obfuscated';
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_a = typeof commander !== "undefined" && commander.Command) === "function" ? _a : Object)
], JavaScriptObfuscatorCLI.prototype, "commands", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_b = typeof IdentifierNamesCacheFileUtils_1.IdentifierNamesCacheFileUtils !== "undefined" && IdentifierNamesCacheFileUtils_1.IdentifierNamesCacheFileUtils) === "function" ? _b : Object)
], JavaScriptObfuscatorCLI.prototype, "identifierNamesCacheFileUtils", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_c = typeof TInputCLIOptions_1.TInputCLIOptions !== "undefined" && TInputCLIOptions_1.TInputCLIOptions) === "function" ? _c : Object)
], JavaScriptObfuscatorCLI.prototype, "inputCLIOptions", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], JavaScriptObfuscatorCLI.prototype, "inputPath", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_d = typeof SourceCodeFileUtils_1.SourceCodeFileUtils !== "undefined" && SourceCodeFileUtils_1.SourceCodeFileUtils) === "function" ? _d : Object)
], JavaScriptObfuscatorCLI.prototype, "sourceCodeFileUtils", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_e = typeof ObfuscatedCodeFileUtils_1.ObfuscatedCodeFileUtils !== "undefined" && ObfuscatedCodeFileUtils_1.ObfuscatedCodeFileUtils) === "function" ? _e : Object)
], JavaScriptObfuscatorCLI.prototype, "obfuscatedCodeFileUtils", void 0);
exports.JavaScriptObfuscatorCLI = JavaScriptObfuscatorCLI;
